import { create } from 'zustand';

export type ExistingSiteStoreReadyBoxId = 'page-ready' | 'margin' | 'delivery' | 'add-more-products';

const DEFAULT_BOX_ID: ExistingSiteStoreReadyBoxId = 'page-ready';

type ExistingSiteStoreReadyUiState = {
  selectedBoxId: ExistingSiteStoreReadyBoxId;
  mobileExpandedBoxId: ExistingSiteStoreReadyBoxId | null;
  setSelectedBoxId: (id: ExistingSiteStoreReadyBoxId) => void;
  setMobileExpandedBoxId: (id: ExistingSiteStoreReadyBoxId | null) => void;
  resetToDefaults: () => void;
};

export const useExistingSiteStoreReadyUiStore = create<ExistingSiteStoreReadyUiState>((set) => ({
  selectedBoxId: DEFAULT_BOX_ID,
  mobileExpandedBoxId: null,
  setSelectedBoxId: (selectedBoxId) => set({ selectedBoxId }),
  setMobileExpandedBoxId: (mobileExpandedBoxId) => set({ mobileExpandedBoxId }),
  resetToDefaults: () =>
    set({
      selectedBoxId: DEFAULT_BOX_ID,
      mobileExpandedBoxId: null,
    }),
}));
